import React, { Component } from 'react';
import { connect } from 'react-redux';
import classes from './SeatsMap.scss';
import SeatsMapList from './SeatsMapList/SeatsMapList';

class SeatsMap extends Component {

    state = {
        height: null
    }

    componentDidMount() {
        if(this.props.seats && Object.keys(this.props.seats.seatLayout.Maindeck.rowInfo).length !== 0) {
            const height = this.divElement.clientHeight;
            this.setState({ height });   
        }
    }

    render() {
        let seatLayout = null;
        let layout = null;
        let seatColumns = [];
        let seatColumnsAfter = [];
        let seatColumnsNaming = [];
        let seatColumnsAfterIndex = [];
        let seatsMapError = null;
        let wingsWidth = 0;
        if (this.props.seats && Object.keys(this.props.seats.seatLayout.Maindeck.rowInfo).length !== 0) {
            const seatsDifference = this.props.seats.seatLayout.Maindeck.equipmentInfo.wingsEnd - this.props.seats.seatLayout.Maindeck.equipmentInfo.wingsStart + 1;
            wingsWidth = (seatsDifference * 26) + (seatsDifference - 1) * 15;
            seatLayout = this.props.seats.seatLayout.Maindeck.rowInfo;
            seatColumns = this.props.seats.seatLayout.Maindeck.equipmentInfo.columns.split('|');
            seatColumnsAfter = this.props.seats.seatLayout.Maindeck.equipmentInfo.columnSpaceAfter.split('|');
            seatColumnsAfterIndex = seatColumnsAfter.map(colAfter => {
                return seatColumns.findIndex(col => {
                    return col === colAfter
                })
            });
            layout = Object.keys(seatLayout).map((seatRow, index) => {
                return <SeatsMapList columnsAfterIndex={seatColumnsAfterIndex} data={seatLayout[seatRow]} key={index} cabinNumber={seatRow} wingsWidth={wingsWidth} wingsStart={this.props.seats.seatLayout.Maindeck.equipmentInfo.wingsStart}/>
            })
            seatColumnsNaming = [...seatColumns];
            let counter = 1;
            for (let i = 0; i < seatColumns.length; i++) {
                for (let j = 0; j < seatColumnsAfter.length; j++) {
                    if (seatColumnsAfter[j] === seatColumns[i]) {
                        seatColumnsNaming.splice(i + counter, 0, ' ');
                        counter++;
                    }
                }
            }
        } else {
            seatsMapError = <div className="u-textColorWhite u-textAlignCenter u-width70Percent u-phone-width90Percent ml-auto mr-auto phone-mb-4 phone-mt-4">
                <span className="mb-2 u-fontSize26 u-fontWeightMedium u-block">We are sorry!</span>
                <p>Seat map is not available right now. Please proceed with the booking and you may get in touch with our call centre to confirm your preferred seat after the booking confirmation.</p>
            </div>
        }
        if(seatsMapError) {
            return seatsMapError;
        } else {
            return (
                <div className={classes.Wrapper}>
                    <div className={classes.Outer}>
                        <div className={classes.Cockpit} style={{
                            height: this.state.height + 20,
                            width: this.state.height/2,
                            borderBottomLeftRadius: this.state.height + 20,
                            borderTopLeftRadius: this.state.height + 20
                        }}></div>
                        <div className={classes.Inner} ref={(divElement) => this.divElement = divElement}>
                            <div className={classes.Nose} style={{
                                height: this.state.height,
                                width: this.state.height/2,
                                borderBottomLeftRadius: this.state.height,
                                borderTopLeftRadius: this.state.height
                            }}></div>
                            <div className={classes.Front}>
                                <ul>
                                    { seatColumnsNaming.reverse().map((seat, index) => {
                                        return <li className={classes.SeatColumn} key={index}>{seat}</li>;
                                    })}
                                </ul>   
                            </div>
                            { layout }
                            <div className={classes.Back}></div>
                        </div>
                    </div>
                </div>
            );
        }
    }
} 

const mapStateToProps = state => {
    return {
        seats: state.seats.seats,
        seatsLoading: state.seats.loading
    }
}

export default connect(mapStateToProps)(SeatsMap);


// WEBPACK FOOTER //
// ./src/components/Addons/Seats/SeatsMap/SeatsMap.js